/**
 * آمار نمای کلی سازمان: عدد خلاصهٔ ادمین اولویت دارد،
 * وگرنه شمارش‌های خودِ GET سازمان (اعضا/اتاق/جلسه) نمایش داده می‌شود.
 * هرگز آمار پلتفرم‌گسترده را جایگزین نمی‌کند.
 */

export function firstNumeric(...values) {
  for (const value of values) {
    if (value === null || value === undefined || value === '') continue;
    const num = Number(value);
    if (!Number.isNaN(num)) return num;
  }
  return null;
}

export function resolveOrganizationOverview(org, summary) {
  const counts = summary?.counts && typeof summary.counts === 'object' ? summary.counts : {};
  const wallet = summary?.wallet && typeof summary.wallet === 'object' ? summary.wallet : {};

  return {
    counts: {
      members: firstNumeric(counts.members, org?.members_count),
      departments: firstNumeric(counts.departments, org?.departments_count),
      rooms: firstNumeric(counts.rooms, org?.rooms_count),
      meetings: firstNumeric(counts.meetings, org?.meetings_count),
      templates: firstNumeric(counts.templates),
      files: firstNumeric(counts.files),
      actions: firstNumeric(counts.actions),
      pending_invitations: firstNumeric(counts.pending_invitations),
    },
    package: summary?.package ?? org?.active_package ?? null,
    entitlements: Array.isArray(summary?.entitlements) ? summary.entitlements : [],
    wallet: {
      cash_irr: firstNumeric(wallet.cash_irr, org?.wallet_cash_irr),
      cash_held_irr: firstNumeric(wallet.cash_held_irr),
    },
    finance: summary?.finance && typeof summary.finance === 'object' ? summary.finance : null,
  };
}

export function normalizeAdminSummaryPayload(payload) {
  if (!payload || typeof payload !== 'object') return payload;
  if (payload.counts && typeof payload.counts === 'object') return payload;
  if (payload.data && typeof payload.data === 'object' && payload.data.counts) {
    return payload.data;
  }
  return payload;
}
